import React from 'react'
import PageWrapper from './PageWrapper'
import LoadingSpinner from './loadingSpinner/LoadingSpinner'

const LoadingScreen = () => (
  <PageWrapper noTabBar viewSelected='/home' title='Validando datos'>
    <section>
      <div className='mt-10 sm:mt-2'>
        <LoadingSpinner
          width='w-60'
          height='h-60'
          loadingMessage='Estamos validando tus datos'
        />
      </div>
      <p className='text-center font-medium text-gray-900 text-xs mt-2 mb-4'>
        ¡Esperá un toque!
        <br /> Nos tomará un par de segundos 😉
      </p>
    </section>
  </PageWrapper>
)

export default LoadingScreen
